import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSwipeable } from 'react-swipeable';
import RegularButton from '../../../../components/RegularButton';
import { IBindingAction } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import { WorkspaceState } from '../../../../reducers/workspace';
import styles from './styles.module.scss';

interface IThankYouScreenProps {
  workspace: WorkspaceState;
  onContinue: IBindingAction;
}

const ThankYouScreen: FunctionComponent<IThankYouScreenProps> = ({
  workspace: { name, logo },
  onContinue
}) => {
  const swipeHandler = useSwipeable({
    onSwipedLeft: onContinue,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className={styles.thankYouScreen}>
      {logo
        ? <img src={logo} alt="company logo" className={styles.img} />
        : name}
      <div className={`text-center cf-title ${styles.title}`}>
        <FormattedMessage
          id="candidateForm.thank.title"
          defaultMessage="Thank you!"
        />
      </div>
      <div className="row justify-content-center">
        <div className={`col-sm-12 col-md-8 text-center cf-subtitle ${styles.subtitle}`}>
          <FormattedMessage
            id="candidateForm.thank.subtitle"
            defaultMessage={`Thank you for providing your references! We will contact them shortly.
            {breakingLine}{breakingLine}
            You can click the link here or refresh this page to monitor your references’ progress and send reminders.`}
            values={{ breakingLine: <br /> }}
          />
        </div>
      </div>
      <RegularButton
        size="lg"
        textIntlId="candidateForm.thank.monitorProgress"
        defaultMessage="Monitor progress"
        iconPosition="right"
        icon={<Icon icon="arrowRight" />}
        onClick={onContinue}
      />
    </div>
  );
};

export default ThankYouScreen;
